// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_autocomplete.js'; import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import vendorList from './routes/vendor-list';
import compare from './routes/compare&one-vs-one';
import oneVsOne from './routes/compare&one-vs-one';
import vendorReviews from './routes/vendor-reviews';
import insights from './routes/insights'
import connectRegistration from './routes/connect-registration';
import archive from './routes/insights';
// import single from './routes/single'

// eslint-disable-next-line no-unused-vars
// const google = window.google;

// Font awesome settings
// import { library, dom, config } from '@fortawesome/fontawesome-svg-core';
// import { faSearch } from '@fortawesome/fontawesome-pro-regular/faSearch';
//
// config.searchPseudoElements = true;
// config.autoReplaceSvg = 'nest';
// config.keepOriginalSource = true;
// library.add(faSearch);
// dom.watch();

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  //Vendor list
  vendorList,
  //Compare page
  compare,
  //one vs one
  oneVsOne,
  //profile
  vendorReviews,
  //single insights
  insights,
  //connect registration
  connectRegistration,
  //Arhive
  archive,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());
